export function getSectionDOM(html, selector = '.shopify-section') {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
}

export function getParentShopifySection(el, selector = '.shopify-section') {
  return el.closest(selector);
}
